import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSectionColumn';
import ModalButtons from '../../components/Modal/ModalButtons';
import LogStyles from './Logs.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { getLogDetailsAction } from '../../redux/actions/userActions';
import { formatHumanDate } from '../../utils/gernalUtils';

const ViewLogModal = ({ logDetails, handleCloseLogModal }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [logData, setLogData] = React.useState();
  // Same tenant-tz resolution as LogTable so the "uploaded on" timestamp
  // in the detail modal renders in the same frame as the main table's
  // "Action Performed At" column. Previous behaviour used
  // new Date(x).toLocaleString() → browser-local — so an ARGOS reviewer
  // in Zurich saw Zurich time while a reviewer in India saw IST for the
  // same audit row, and neither matched the main table.
  const tenantTz = useSelector(s => s?.tenantConfig?.config?.locale?.timezone) || 'UTC';

  const getLogData = async id => {
    const data = await dispatch(getLogDetailsAction(id));
    setLogData(data);
  };

  // React.useEffect(() => {
  //   console.log(logData);
  // }, [logData]);

  React.useEffect(() => {
    if (logDetails.data._id) {
      getLogData(logDetails.data._id);
    }
  }, [logDetails.data]);

  return (
    <Modal show={logDetails.status}>
      <ModalHeading heading={t('screens.logs.logContent')} />
      <ModalForm style={{ marginBottom: '2.5rem' }}>
        <InputsSection style={{ width: '45rem' }}>
          <div className={LogStyles.logData}>
            {logData && logData.data && logData.data.content && (
              <>
                {logData.data.type === 'login' || logData.data.type === 'login-by-token' ? (
                  <div>
                    <p>
                      {t('screens.logs.labelEmail')}: <span>{logData.data.content.email}</span>
                    </p>
                    <p>
                      {t('screens.logs.labelName')}: <span>{logData.data.content.name}</span>
                    </p>
                    <p>
                      {t('screens.logs.labelRole')}: <span>{logData.data.content.role}</span>
                    </p>
                  </div>
                ) : logData.data.type === 'download-file' ? (
                  logData.data.content.file && (
                    <div>
                      <p>
                        {t('screens.logs.labelFileName')}: <span>{logData.data.content.file.name}</span>
                      </p>
                      <p>
                        {t('screens.logs.labelFileUploadedOn')}: <span>{formatHumanDate(logData.data.content.file.updatedAt, true, tenantTz)}</span>
                      </p>
                    </div>
                  )
                ) : logData.data.type === 'reset-password' ? (
                  <div>
                    <p>
                      {t('screens.logs.labelActionPerformed')}: <span>{logDetails.data.action}</span>
                    </p>
                  </div>
                ) : null}
              </>
            )}
          </div>
        </InputsSection>
        <ModalButtons cancelButtonLabel={t('screens.logs.cancel')} onCancel={handleCloseLogModal} />
      </ModalForm>
    </Modal>
  );
};

export default ViewLogModal;
